export enum SchedulingStatus {
  ALL = 'ALL',
  SCHEDULED = 'SCHEDULED',
  UNSCHEDULED = 'UNSCHEDULED',
  SCHEDULED_IN_ANALYSIS = 'SCHEDULED_IN_ANALYSIS',
  SCHEDULING_SCHEDULED = 'SCHEDULING_SCHEDULED',
  SCHEDULING_IN_ANALYZE = 'SCHEDULING_IN_ANALYZE',
  SCHEDULING_CANCELED = 'SCHEDULING_CANCELED',
  CREATE_NEW_SCHEDULE = 'CREATE_NEW_SCHEDULE',
  SCHEDULE_CANCELLATION_REQUEST = 'SCHEDULE_CANCELLATION_REQUEST',
  SCHEDULE_CHANGED_REQUEST = 'SCHEDULE_CHANGED_REQUEST'
}

export enum SchedulingStatusLocated {
  ALL = 'Todos os pedidos',
  SCHEDULED = 'Agendado',
  UNSCHEDULED = 'Não agendado',
  SCHEDULED_IN_ANALYSIS = 'Em análise',
  SCHEDULING_SCHEDULED = 'Agendado',
  SCHEDULING_IN_ANALYZE = 'Agendamento em análise',
  SCHEDULING_CANCELED = 'Agendamento cancelado',
  CREATE_NEW_SCHEDULE = 'Criar novo agendamento',
  SCHEDULE_CANCELLATION_REQUEST = 'Solicitação de cancelamento',
  SCHEDULE_CHANGED_REQUEST = 'Solicitação de agendamento'
}
